import React from 'react'
import { Day as LibDay, DayProps } from 'react-day-picker'

export const Day = (props: DayProps) => {
  const { modifiers } = props

  return (
    <LibDay
      {...props}
      className={`${modifiers.startRange ? 'pr-0' : modifiers.endRange ? 'pl-0' : modifiers.inRange ? 'px-0' : ''}`}
    />
  )
}
